import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch categories data from Jekyll-generated JSON
    // Use process.env.PUBLIC_URL to ensure correct path in production
    fetch(`${process.env.PUBLIC_URL}/categories_data.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setCategories(data.categories);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching categories:", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${process.env.PUBLIC_URL}/images/copenhagen.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <div className="App">
      {/* --- Hero Section --- */}
      <section className="hero-section" style={heroStyle}>
        <div className="hero-text">
          <h1>Junho's record</h1>
          <p>Exploring the synergy between nature and urban landscapes.</p>
        </div>
      </section>

      {/* --- Content Section (appears on scroll) --- */}
      <section className="content-section">
        <h2>Blog Categories</h2>
        {loading && <p>Loading categories...</p>}
        {error && <p>Error loading categories: {error.message}</p>}
        {!loading && !error && (
          <div className="categories-grid">
            {categories.map(category => (
              <div key={category.name} className="category-card">
                <h3>
                  <a href={category.url}>{category.display_name}</a>
                </h3>
                <p>{category.posts.length} posts</p>
                {/* You can add a short description for each category here if available */}
                {/* <ul>
                  {category.posts.map(post => (
                    <li key={post.url}>
                      <a href={post.url}>{post.title}</a>
                    </li>
                  ))}
                </ul> */}
              </div>
            ))}
          </div>
        )}
        
        <p style={{marginTop: '2rem'}}>
          To add more content or customize the display, you can edit the <code>react-app/src/App.js</code> file.
        </p>
      </section>
    </div>
  );
}

export default App;
